import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { rootReducer } from './combine_reducers';
import { transform_users_list } from '../modules/UserManagement/User_list/redux/middleware/transform_users_list';
import { transform_dataMiddleware } from './middlewares/transform_data.middleware';
import rootSaga from './root.saga';

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger({ collapsed: true });
const createStoreWithMiddleware = applyMiddleware(sagaMiddleware, logger, transform_users_list, transform_dataMiddleware);
const store = createStore(rootReducer, compose(createStoreWithMiddleware));

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/redux/configureReduxStore.js